// extracted by mini-css-extract-plugin
export default {"search":"newsbreak_search__Fk7gr","fieldList":"newsbreak_fieldList__7Fs3S","field":"newsbreak_field__iEXXX","count":"newsbreak_count__i8LTz","list":"newsbreak_list__P68CR"};